import styled from "styled-components";

import { TextAlign } from "@sso/types";

interface THProps {
  sortable?: boolean;
  textAlign?: TextAlign;
}

interface TDProps {
  textAlign?: TextAlign;
  padding?: string;
}

export const TableWrapper = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  overflow: auto;
  margin-bottom: 1rem;
`;

export const Table = styled.table`
  width: 100%;
  max-width: 100%;
  border-spacing: 0;
  th,
  td {
    vertical-align: middle;
    font-size: 0.85rem;
    user-select: none;
  }
  th {
    font-size: 1rem;
    padding: 0.6rem 0.4rem;
    text-transform: capitalize;
    border-bottom: 4px solid ${p => p.theme.colors.primary.dark};
  }
  thead {
    top: 0;
    position: sticky;
    z-index: ${p => p.theme.zIndex.positiveOne};
    background-color: ${p => p.theme.colors.primary.main};
    color: ${p => p.theme.colors.primary.contrastText};
  }

  tbody > tr {
    &:nth-of-type(odd) {
      background-color: rgba(0, 0, 0, 0.05);
    }
    &:hover {
      background-color: rgba(0, 0, 0, 0.15);
    }
  }
`;

export const LayoutTable = styled(Table)`
  th,
  td {
    &:first-child {
      padding-left: 1rem;
      width: 35%;
    }
  }
`;

export const TH = styled.th<THProps>`
  cursor: ${p => (p.sortable ? "pointer" : "default")};
  text-align: ${p => p.textAlign || "start"};
`;

export const TD = styled.td<TDProps>`
  padding: ${p => p.padding || "0.5rem 0.4rem"};
  text-align: ${p => p.textAlign || "start"};
`;
